import { render, staticRenderFns } from "./TransitionRound.vue?vue&type=template&id=0684b510&scoped=true"
import script from "./TransitionRound.vue?vue&type=script&lang=ts"
export * from "./TransitionRound.vue?vue&type=script&lang=ts"
import style0 from "./TransitionRound.vue?vue&type=style&index=0&id=0684b510&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0684b510",
  null
  
)

export default component.exports